import uniqueId from 'lodash/uniqueId';
import { useCallback, useState } from 'react';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { ebGlobalChannel } from 'src/lib/events-bridge';
import useSubscription from 'src/lib/events-bridge/hooks/useSubscription';
import EBAPIs from 'src/lib/events-bridge/topics';
const getInitialState = () => ({
    visible: false,
    component: null,
    onClose() { },
    direction: 'from-bottom',
    id: uniqueId(),
});
export default function useOverlay() {
    const [state, setState] = useState(getInitialState());
    const hide = useCallback((id) => {
        setState(prevState => {
            if (typeof id === 'string') {
                if (prevState.id !== id) {
                    return prevState;
                }
            }
            return {
                ...prevState,
                onClose() { },
                visible: false,
                component: null,
            };
        });
    }, []);
    const show = useCallback((data) => {
        setState({
            visible: true,
            onClose: hide,
            component: data.component,
            direction: data.direction,
            style: data.style,
            id: data.id ?? uniqueId(),
        });
    }, [hide]);
    const getState = useStableCallback(() => {
        return state;
    });
    useSubscription(EBAPIs.helperViews.overlay.show, show);
    useSubscription(EBAPIs.helperViews.overlay.hide, hide);
    useSubscription(EBAPIs.helperViews.overlay.getState, getState);
    return [state];
}
export const overlayHelperViewActions = {
    show(data) {
        ebGlobalChannel.publish(EBAPIs.helperViews.overlay.show, data);
    },
    hide(id) {
        ebGlobalChannel.publish(EBAPIs.helperViews.overlay.hide, id);
    },
    getState() {
        return ebGlobalChannel.request(EBAPIs.helperViews.overlay.getState);
    },
};
